import { createSlice } from '@reduxjs/toolkit';

// Helper functions
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('language');
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn("Failed to load language from localStorage", e);
    return undefined;
  }
};

const saveState = (state) => {
  try {
    localStorage.setItem('language', JSON.stringify(state));
  } catch (e) {
    console.warn("Failed to save language to localStorage", e);
  }
};

// Initial state: load from localStorage or default to English
const persistedState = loadState();

const initialState = persistedState || {
  selected: 'en',
  options: [], // [{ code, label }]
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.selected = action.payload;
      saveState(state); // save immediately to localStorage
    },
    setOptions(state, action) {
      state.options = Array.isArray(action.payload) ? action.payload : state.options;
      saveState(state); // save immediately to localStorage
    },
  },
});

export const { setLanguage, setOptions } = languageSlice.actions;
export default languageSlice.reducer;